var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMetabolicHealth = function SvgMetabolicHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.751 11.771c0-.682.187-1.32.511-1.866m4.25 5.357a3.66 3.66 0 0 1-3.544-.767m6.09-3.011a3.66 3.66 0 0 0-4.161-3.336"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.433 4.004a7.86 7.86 0 0 1 7.861 7.862m-7.861-7.862 1.672-1.385m-1.672 1.385 1.296 1.72M12.326 19.854a7.86 7.86 0 0 1-7.862-7.862m7.862 7.861-1.673 1.386m1.673-1.386-1.297-1.719"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.152,
    cy: 8.643,
    r: 1.401
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.751,
    cy: 13.485,
    r: 1.401
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.553,
    cy: 13.833,
    r: 2.294
  }))));
};
export default SvgMetabolicHealth;